import * as runtime from '@/api/runtime'
import {
  BatchTrcAcceptMarcRegisterRequest,
  BatchTrcAcceptMarcRegisterRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcAcceptMarcRegisterCondition,
  BatchTrcAcceptMarcRegisterConditionFromJSON
} from '@/api/models/batch/BatchTrcAcceptMarcRegisterCondition'

/**
 * 帳票作成
 */
export class BatchTrcAcceptMarcRegisterApi extends runtime.BaseAPI {
  async return(request: BatchTrcAcceptMarcRegisterRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/order-accept/trc-accept-marc-register`,
      BatchTrcAcceptMarcRegisterRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcAcceptMarcRegisterCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcAcceptMarcRegisterConditionFromJSON(jsonValue)
    ).value()
  }
}
